const objectToQueryString = (obj) => {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}

const getEndpointFromUrl = (url) => {
  const urlEndpont = url.split('/').pop().split("?")[0]
  // console.log(urlEndpont)
  return urlEndpont
}

const loadZohoForm = (url, uid, data, formId = "zoho-form") => {
  try {
    const query = objectToQueryString(data)
    const src = `${url}&uid=${uid}&${query}`
    console.log(src)
    var f = document.createElement("iframe")
    f.src = src
    f.style.border = "none"
    f.style.height = "1147px"
    f.style.width = "100%"
    f.style.backgroundColor = "transparent"
    f.style.transition = "all 0.5s ease"// No I18N
    var d = document.getElementById(formId)
    d.appendChild(f)

    // const urlEndpont = getEndpointFromUrl(url)

    // window.addEventListener('message', function (event) {
    //   console.log("event.data", event.data)
    //   if (event && event.data && typeof event.data === 'string' && event.data.search(urlEndpont) === 0) {
    //     var zf_ifrm_data = event.data.split("|")
    //     var zf_perma = zf_ifrm_data[0]
    //     var zf_ifrm_ht_nw = (parseInt(zf_ifrm_data[1], 10) + 0) + "px"
    //     var iframe = document.getElementById(formId).getElementsByTagName("iframe")[0]
    //     if ((iframe.src).indexOf('formperma') > 0 && (iframe.src).indexOf(zf_perma) > 0) {
    //       var prevIframeHeight = iframe.style.height
    //       if (prevIframeHeight != zf_ifrm_ht_nw) {
    //         iframe.style.height = zf_ifrm_ht_nw
    //       }
    //     }
    //   }
    // }, false)
  } catch (e) { console.log(e)}
}

export {
  loadZohoForm
}
